<template>
  <form class="card rounded-top" @submit.prevent="save">
    <div class="row card-body ">
      <div class="form-group col-6">
        <w-input :model="$schema.name" :title="$t($schema.name.$schema.title)" />
      </div>

      <div class="form-group col-6">
        <w-input :model="$schema.price" :title="$t($schema.price.$schema.title)" />
      </div>

      <div class="col-12 text-right card-actions">
        <button class="btn btn-dark btn-lg rounded-pill" @click.prevent="cancel">
          {{ $t('buttons.cancel') }}
        </button>

        <button type="submit" class="btn btn-smart btn-lg rounded-pill">
          {{ stepper ? $t('buttons.next') : $t('buttons.save') }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { formViewMixin } from '@/mixins/formView';
import schema from '@/schemas/fee.schema';

const emptyData = () => ({
  name: '',
  price: null,
  clubId: null,
  teamId: null
});

const messages = {
  added: 'messages.fee.added',
  addError: 'messages.fee.addError',
  updated: 'messages.fee.updated',
  updateError: 'messages.fee.updateError'
};

// @vuese
// Formularz składek
// @group Fee
export default {
  schema,
  mixins: [formViewMixin('fee', messages, emptyData)]
};
</script>